(function ($) {
    //----------------------------------------------------------//
    //-------------- Start :  SerializeObject ---------------//
    //----------------------------------------------------------//
    $.fn.serializeObject = function () {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            }
            else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };
    //----------------------------------------------------------//
    //-------------- Start :  AutoComplete ---------------//
    //----------------------------------------------------------//
    // maintain a reference to the existing function
    //var baseAutocomplete = $.fn.autocomplete;
    // ...before overwriting the jQuery extension point
    $.fn.autocompleteExtension = function (options) {
        // This is the easiest way to have default options.
        var settings = $.extend({
            onDataLoad: function () { }
        }, $.fn.autocompleteExtension.defaults, options);
        var ControlID = '#' + this.attr("ID");
        var path = settings.API;
        $.each(settings.ParentID, function myfunction(index, value) {
            path = path + '/' + $(value).val();
        });
        settings.source = function (request, response) {
            $.ajax({
                url: path,
                type: "GET",
                dataType: "json",
                data: { Prefix: request.term },
                success: function (data) {
                    response($.map(data, function (item) {
                        return { label: item[settings.nameColumn], value: item[settings.nameColumn], id: item[settings.valueColumn] };
                    }));
                }
            });
        };
        //settings.messages = {
        //    noResults: "", results: ""
        //};
        var result = $(ControlID).autocomplete({
            source: settings.source,
            change: function (event, ui) {
                var id = ui.item[settings.valueColumn];
                var hiddenControlID = ControlID;
                hiddenControlID = hiddenControlID.replace("AutoComplete", "");
                hiddenControlID = hiddenControlID.replace("Auto", "");
                hiddenControlID = hiddenControlID.replace("AC", "");
                $(hiddenControlID).val(id);
            }
        });
        // original behavior - use function.apply to preserve context
        //var result = baseAutocomplete.apply(this, settings);
        // stuff I will be extending that doesn't affect/change the way .autocomplete() works
        // preserve return value (probably the jQuery object...)
        return result;
    };
    // Plugin defaults – added as a property on our plugin function.
    $.fn.autocompleteExtension.defaults = {
        nameColumn: "name",
        valueColumn: "id",
        ParentID: ""
    };
    //----------------------------------------------------------//
    //-------------- End :  AutoComplete ---------------//
    //----------------------------------------------------------//
    //----------------------------------------------------------//
    //-------------- Start :  Cascading Dropdown ---------------//
    //----------------------------------------------------------//
    $.fn.DropDownList = function (options) {
        // This is the easiest way to have default options.
        var settings = $.extend({
            onDataLoad: function () { }
        }, $.fn.DropDownList.defaults, options);
        var ControlID = '#' + this.attr("ID");
        var para = '';
        var items = '';
        var newVal = '';
        if (settings.ParentID != "") {
            para = $(settings.ParentID).val();
        }
        if (settings.defaultOption != "" && !settings.ValueRequired) {
            items += '<option value="' + settings.defaultValue + '" selected="selected"> ' + settings.defaultOption + '</option>';
            newVal = settings.defaultValue;
        }
        var path = settings.API + para + settings.additionalPathPara;
        $.getJSON(path, "", function (resultData) {
            $.each(resultData, function myfunction(index, data) {
                if ((settings.SelectedValue == 0 && index == 0
                    && (settings.defaultOption == "" || settings.ValueRequired || (settings.defaultOption != "" && settings.defaultValue != 0)))
                    || settings.SelectedValue == data[settings.idColumn]) {
                    items += '<option value="' + data[settings.idColumn] + '" selected="selected">' + data[settings.nameColumn] + '</option>';
                    newVal = data[settings.idColumn];
                }
                else
                    items += '<option value="' + data[settings.idColumn] + '"> ' + data[settings.nameColumn] + '</option>';
            });
            $(ControlID).empty();
            $(ControlID).html(items);
            $(ControlID).val(newVal).change();
            // call the callback and apply the scope:
            settings.onDataLoad.call(this, resultData, newVal);
            if (resultData.length > 0) {
                if (newVal == '' && settings.defaultOption == '') {
                    $(ControlID + ' option').eq(0).prop('selected', true);
                    newVal = settings.resultData[0][settings.idColumn];
                }
            }
        });
        return this;
    };
    // Plugin defaults – added as a property on our plugin function.
    $.fn.DropDownList.defaults = {
        API: "",
        ParentID: "",
        SelectedValue: "",
        idColumn: "id",
        nameColumn: "name",
        additionalPathPara: "",
        defaultOption: "",
        defaultValue: "",
        ValueRequired: false
    };
    //----------------------------------------------------------//
    //-------------- End :  Cascading Dropdown ---------------//
    //----------------------------------------------------------//
    //----------------------------------------------------------//
    //-------------- Start :  Show Auto closing alert---------------//
    //----------------------------------------------------------//
    $.AutoClosingAlert = function (options) {
        // This is the easiest way to have default options.
        var settings = $.extend({}, $.AutoClosingAlert.defaults, options);
        $(".alert-" + settings.Type).show().css('opacity', 1);
        window.setTimeout(function () {
            $(".alert-" + settings.Type).fadeTo(1000, 0).slideUp(1000, function () {
                $(this).hide();
            });
        }, 5000);
        return this;
    };
    // Plugin defaults – added as a property on our plugin function.
    $.AutoClosingAlert.defaults = {
        Type: "danger"
    };
}(jQuery));
function AutoClosingAlert(type, Message) {
    if (Message == "" && type == "danger") {
        Message = "A problem has been occurred while submitting your data.";
    }
    else if (Message == "" && type == "success") {
        Message = "Data saved successfully.";
    }
    $(".alert-" + type).show().css('opacity', 1);
    if (type == 'danger') {
        $('#ErrorMsg').text(Message);
    }
    else if (type == 'success') {
        $('#SuccessMsg').text(Message);
    }
    window.setTimeout(function () {
        $(".alert-" + type).fadeTo(50, 0).slideUp(1000, function () {
            $(this).hide();
        });
    }, 7000);
}
function SetDropDownList(ControlID, API, ParentID, SelectedValue, nameColumn, additionalPathPara, defaultOption, defaultValue) {
    if (nameColumn === void 0) { nameColumn = "name"; }
    if (additionalPathPara === void 0) { additionalPathPara = ""; }
    if (defaultOption === void 0) { defaultOption = ""; }
    if (defaultValue === void 0) { defaultValue = ""; }
    var para = '';
    var items = '';
    var newVal = '';
    if (ParentID != "") {
        para = $(ParentID).val();
    }
    if (defaultOption != "") {
        items += '<option value="' + defaultValue + '" selected="selected"> ' + defaultOption + '</option>';
        newVal = defaultValue;
    }
    $.getJSON(API + para + additionalPathPara, "", function (resultData) {
        $.each(resultData, function myfunction(index, data) {
            if ((SelectedValue == 0 && index == 0 && (defaultOption == "" || (defaultOption != "" && defaultValue != 0)))
                || SelectedValue == data.ID) {
                items += '<option value="' + data.ID + '" selected="selected">' + data[nameColumn] + '</option>';
                newVal = data.ID;
            }
            else
                items += '<option value="' + data.ID + '"> ' + data[nameColumn] + '</option>';
        });
        if (newVal == '' && defaultOption == '') {
            $(ControlID + ' option').eq(0).prop('selected', true);
            newVal = resultData[0].id;
        }
        $(ControlID).empty();
        $(ControlID).html(items);
        $(ControlID).val(newVal).change();
        if (resultData.length > 0) {
        }
    });
}
//----------------------------------------------------------//
//-------------- Start : jQuery Dialog ---------------//
//----------------------------------------------------------//
function CloseDetailPopUp(popCtlID) {
    $(popCtlID).dialog('close');
}
function ShowDetailPopUp(popCtlID, header, width) {
    if (width == '' || width == undefined)
        width = "auto";
    $(function () {
        var $myDialog = $(popCtlID).dialog({
            modal: true,
            resizable: true,
            height: "auto",
            width: width,
            maxHeight: $(window).height() - 100,
            autoOpen: true,
            closeOnEscape: true,
            dialogClass: 'dialog-info',
            create: function () {
                $(this).siblings().find(".ui-dialog-title").html(header);
            },
            open: function (type, data) {
                $(this).parent().appendTo("form:first");
            }
        });
    });
    //return $myDialog.dialog('open');
}
function MessageDialog(header, body, type) {
    $(function () {
        if (header == "")
            header = type;
        if (type == "Error") {
            header = '<i class=\"fa fa-warning pull-left m-t-xs\"></i>' + header;
            if (body == "")
                body = "System error occcurred.";
        }
        else if (type == "Save") {
            header = '<i class=\"fa fa-save pull-left m-t-xs\"></i>' + header;
            if (body == "")
                body = "Data Saved Successully.";
        }
        else if (type == "Update") {
            header = '<i class=\"fa fa-edit pull-left m-t-xs\"></i>' + header;
            if (body == "")
                body = "Data Updated Successully.";
        }
        else if (type == "Create") {
            header = '<i class=\"fa fa-save pull-left m-t-xs\"></i>' + header;
            if (body == "")
                body = "Record Created Successully.";
        }
        else if (type == "NoDataFound") {
            header = '<i class=\"fa glyphicon-warning-sign pull-left m-t-xs\"></i>' + header;
            if (body == "")
                body = "No Data Found";
        }
        var $msgDialog = $('<div></div>')
            .html(body)
            .dialog({
            modal: true,
            resizable: false,
            height: "auto",
            modal: true,
            autoOpen: false,
            closeOnEscape: true,
            dialogClass: 'dialog-' + type,
            create: function () {
                $(this).siblings().find(".ui-dialog-title").html(header);
            },
            //open: function (type, data) {
            //    $(this).parent().appendTo("form:first");
            //},
            buttons: {
                "OK": function () {
                    $(this).dialog("close");
                }
            }
        });
        return $msgDialog.dialog('open');
    });
}
function MessageDialogWithEvent(header, body, type, okfunction) {
    $(function () {
        if (header == "")
            header = type;
        if (type == "Error") {
            header = '<i class=\"fa fa-warning pull-left m-t-xs\"></i>' + header;
            if (body == "")
                body = "System error occcurred.";
        }
        else if (type == "Save") {
            header = '<i class=\"fa fa-save pull-left m-t-xs\"></i>' + header;
            if (body == "")
                body = "Data Saved Successully.";
        }
        else if (type == "Update") {
            header = '<i class=\"fa fa-edit pull-left m-t-xs\"></i>' + header;
            if (body == "")
                body = "Data Updated Successully.";
        }
        else if (type == "Create") {
            header = '<i class=\"fa fa-save pull-left m-t-xs\"></i>' + header;
            if (body == "")
                body = "Record Created Successully.";
        }
        else if (type == "NoDataFound") {
            header = '<i class=\"fa glyphicon-warning-sign pull-left m-t-xs\"></i>' + header;
            if (body == "")
                body = "No Data Found";
        }
        var $msgDialog = $('<div></div>')
            .html(body)
            .dialog({
            modal: true,
            resizable: false,
            height: "auto",
            modal: true,
            autoOpen: false,
            closeOnEscape: true,
            dialogClass: 'dialog-' + type,
            create: function () {
                $(this).siblings().find(".ui-dialog-title").html(header);
            },
            //open: function (type, data) {
            //    $(this).parent().appendTo("form:first");
            //},
            buttons: {
                "OK": function () {
                    if (okfunction != "" && okfunction != undefined)
                        okfunction();
                    $(this).dialog("close");
                }
            }
        });
        return $msgDialog.dialog('open');
    });
}
function ConfirmDialogWithPostBackEvent(postbackCtl, header, body, type, postbackEvent) {
    if (type == "Delete") {
        header = '<i class=\"fa fa-trash pull-left m-t-xxs\"></i>' + header;
        if (body == "")
            body = "Are you sure you want to Delete ?";
    }
    else if (type == "Update") {
        header = '<i class=\"fa fa-edit pull-left m-t-xxs\"></i>' + header;
        if (body == "")
            body = "Are you sure you want to Update ?";
    }
    var $myDialog = $('<div></div>')
        .html(body)
        .dialog({
        modal: true,
        resizable: false,
        height: "auto",
        modal: true,
        autoOpen: true,
        closeOnEscape: true,
        dialogClass: 'dialog-' + type,
        create: function () {
            $(this).siblings().find(".ui-dialog-title").html(header);
        },
        buttons: {
            "OK": function () {
                $(this).dialog("close");
                if (postbackEvent == "") {
                    if (postbackCtl.name == "") {
                        eval($('#' + postbackCtl.id).attr('href'));
                    }
                    else
                        __doPostBack(postbackCtl.name, "");
                }
                else
                    __doPostBack(postbackEvent, "");
            }, "Cancel": function () {
                $(this).dialog("close");
            }
        }
    });
    return $myDialog.dialog('open');
}
function ConfirmDialog(postbackCtl, header, body, type) {
    ConfirmDialogWithPostBackEvent(postbackCtl, header, body, type, "");
}
//----------------------------------------------------------//
//-------------- End : jQuery Dialog ---------------//
//----------------------------------------------------------//
//----------------------------------------------------------//
//-------------- Start : Password Strenght Check---------------//
//----------------------------------------------------------//
function PasswordStrengthInit(textControlID) {
    $(textControlID).keypress(function (e) {
        if (!/[A-Za-z0-9_~\-!@#\$%\^&\*\(\)]+$/.test(String.fromCharCode(e.which))) {
            return false;
        }
    });
    var container = $(document.createElement('div'));
    $(container).append('<div id="pswd_info" style="display:none;"> <div id="div_pswd_Strength" style="display:none;"><hr class="m-t-xs m-b-xs" /><span id="pswdStrengthHelp" class="text-center"> </span><hr class="m-t-xs m-b-xs" /></div> <h6>Secure password requirements:</h6>'
        + '<span id="number"><i id="numbershow" style="visibility:hidden" class="fa fa-check text-success"></i> <i class="fa fa-circle" style="font-size:9px"></i><strong> At least one number</strong></span><br />'
        + '<span id="capital"><i  id="capitalshow" style="visibility:hidden" class="fa fa-check text-success"></i> <i class="fa fa-circle" style="font-size:9px"></i><strong> At least one upper and one lower case letter</strong></span><br />'
        + '<span id="length"><i id="lengthshow" style="visibility:hidden" class="fa fa-check text-success"></i> <i class="fa fa-circle" style="font-size:9px"></i><strong> 8-12 characters in length</strong></span><br />'
        + ''
        + '    <div id="passwordIndicator">'
        + '        <p><span id="possibilities" class="reset"></span></p>'
        + '        <p> Time to crack using <input type="text" id="nodes" value="1" size="5" /> core(s):</p>'
        + '        <p><span id="rates" class="reset"></span></p>'
        + '    </div >'
        + '</div >');
    var position = $(textControlID).offset();
    container.css({
        position: 'absolute',
        top: position.top,
        left: position.left
    });
    $(textControlID).after(container.html());
    //you have to use keyup, because keydown will not catch the currently entered value
    $(textControlID).keyup(function () {
        // set password variable
        var pswd = $(this).val();
        var strength = 0;
        //validate the length
        if (pswd.length >= 8 && pswd.length <= 12) {
            strength += 1;
            //$('#length').removeClass('invalid').addClass('valid');
            $("#lengthshow").css('visibility', 'visible');
        }
        else {
            //$('#length').removeClass('valid').addClass('invalid');
            $("#lengthshow").css('visibility', 'hidden');
        }
        //special character
        if (pswd.match(/([!,%,&,@,#,$,£,^,*,?,_,~,(,),_,+])/)) {
            strength += 1;
            //$('#letter').removeClass('invalid').addClass('valid');
            $("#lettershow").css('visibility', 'visible');
        }
        else {
            //$('#letter').removeClass('valid').addClass('invalid');
            $("#lettershow").css('visibility', 'hidden');
        }
        //password contains both lower or uppercase characters
        ///([a-zA-Z])/
        if (pswd.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
            strength += 1;
            // $('#capital').removeClass('invalid').addClass('valid');
            $("#capitalshow").css('visibility', 'visible');
        }
        else {
            // $('#capital').removeClass('valid').addClass('invalid');
            $("#capitalshow").css('visibility', 'hidden');
        }
        //validate numbers and characters
        if (pswd.match(/([a-zA-Z])/) && pswd.match(/([0-9])/)) {
            strength += 1;
            //$('#number').removeClass('invalid').addClass('valid');
            $("#numbershow").css('visibility', 'visible');
        }
        else {
            //$('#number').removeClass('valid').addClass('invalid');
            $("#numbershow").css('visibility', 'hidden');
        }
        //if it has two special characters, increase strength value
        if (pswd.match(/(.*[!,%,&,@,#,$,£,^,*,?,_,~,(,),_,+].*[!,",%,&,@,#,$,^,*,?,_,~,(,),_,+])/))
            strength += 1;
        if (strength <= 1) {
            $(textControlID).removeClass('Validpass');
            $('#pswdStrengthHelp').removeClass();
            $('#pswdStrengthHelp').addClass('VeryPoorStrength');
            $('#pswdStrengthHelp').text('Very Poor');
            $('#div_pswd_Strength').css("display", "block");
            $("#pswdStrengthHelp").css("color", "#f21b1b");
            $("#pswdStrengthHelp").css("font-weight", "bold");
        }
        else if (strength == 2) {
            $(textControlID).removeClass('Validpass');
            $('#pswdStrengthHelp').removeClass();
            $('#pswdStrengthHelp').addClass('WeakStrength');
            $('#pswdStrengthHelp').text('Weak');
            $('#div_pswd_Strength').css("display", "block");
            $("#pswdStrengthHelp").css("color", "#f21b1b");
            $("#pswdStrengthHelp").css("font-weight", "bold");
        }
        else if (strength == 3) {
            $(textControlID).removeClass('Validpass');
            $('#pswdStrengthHelp').removeClass();
            $('#pswdStrengthHelp').addClass('AverageStrength');
            $('#pswdStrengthHelp').text('Average');
            $('#div_pswd_Strength').css("display", "block");
            $("#pswdStrengthHelp").css("color", "#e9e412");
            $("#pswdStrengthHelp").css("font-weight", "bold");
        }
        else if (strength == 4) {
            $(textControlID).addClass('Validpass');
            $('#pswdStrengthHelp').removeClass();
            $('#pswdStrengthHelp').addClass('GoodStrength');
            $('#pswdStrengthHelp').text('Good');
            $('#div_pswd_Strength').css("display", "block");
            $("#pswdStrengthHelp").css("color", "#e9e412");
            $("#pswdStrengthHelp").css("font-weight", "bold");
        }
        else if (strength > 4) {
            $(textControlID).addClass('Validpass');
            $('#pswdStrengthHelp').removeClass();
            $('#pswdStrengthHelp').addClass('ExcellentStrength');
            $('#pswdStrengthHelp').text('Strong');
            $('#div_pswd_Strength').css("display", "block");
            $("#pswdStrengthHelp").css("color", "#1a9c39");
            $("#pswdStrengthHelp").css("font-weight", "bold");
        }
    }).focus(function () {
        $('#pswd_info').show();
        $('#PasswordEye').hide();
    }).blur(function () {
        $('#pswd_info').hide();
        $('#PasswordEye').show();
    });
    $("#Password").keyup(function (event) {
        strengthMeter("Password", $("#nodes").val());
    });
    $("#nodes").keyup(function (event) {
        strengthMeter("Password", $("#nodes").val());
    });
    strengthMeter("Password", $("#nodes").val());
}
function strengthMeter(passwordFieldId, nodes) {
    // init undefined 
    if ('undefined' === typeof (nodes)) {
        var nodes = 1;
    }
    // init character classes
    var password = $("#" + passwordFieldId).val();
    var numEx = /\d/;
    var lcEx = /[a-z]/;
    var ucEx = /[A-Z]/;
    var syEx = /\W/;
    var meterMult = 1;
    var character_set_size = 0;
    // loop over each char of the password and check it per regexes above.
    // weight numbers, upper case and lowercase at .75, 1 and .25 respectively.
    if (numEx.test(password)) {
        character_set_size += 10;
    }
    if (ucEx.test(password)) {
        character_set_size += 26;
    }
    if (lcEx.test(password)) {
        character_set_size += 26;
    }
    if (syEx.test(password)) {
        character_set_size += 32;
    }
    // assume that 100% is a meterMult of maxMulti
    var strength = Math.pow(character_set_size, password.length);
    // init crackers at hashes/second
    // all numbers from slowest computer here http://hashcat.net/oclhashcat-plus/
    var rateMd5 = 1333000000;
    var rateSHA1 = 433000000;
    var rateMd5crypt = 855000;
    var rateBcrypt = 604;
    // calculate a human readable time based on seconds and nodes
    var secMd5 = secondsToStr(toFixed(strength / (rateMd5 * nodes)));
    var secSHA1 = secondsToStr(toFixed(strength / (rateSHA1 * nodes)));
    var secMd5crypt = secondsToStr(toFixed(strength / (rateMd5crypt * nodes)));
    var secBcrypt = secondsToStr(toFixed(strength / (rateBcrypt * nodes)));
    var rates = "MD5: " + secMd5 + " <br/>" +
        "SHA1: " + secSHA1 + "<br/>" +
        "MD5Crypt: " + secMd5crypt + "<br/>" +
        "Bcrypt: " + secBcrypt + "<br/>" +
        " ";
    // if null, don't show anything
    if (password.length > 0) {
        $("#passwordIndicator").show();
        $("#possibilities").html(numberWithCommas(strength) + " Possibilities");
        $("#nodes").val(nodes);
        $("#rates").html(rates);
        $("#passwordIndicator").hide();
    }
    else {
        $("#passwordIndicator").hide();
    }
}
// thanks http://stackoverflow.com/questions/2901102/how-to-print-number-with-commas-as-thousands-separators-in-javascript
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
// thanks http://stackoverflow.com/questions/8211744/convert-milliseconds-or-seconds-into-human-readable-form
function secondsToStr(seconds) {
    // TIP: to find current time in milliseconds, use:
    // var milliseconds_now = new Date().getTime();
    seconds = Math.round(seconds);
    var numyears = Math.floor(seconds / 31536000);
    if (numyears) {
        return numberWithCommas(numyears) + ' year' + ((numyears > 1) ? 's' : '');
    }
    var numdays = Math.floor((seconds % 31536000) / 86400);
    if (numdays) {
        return numdays + ' day' + ((numdays > 1) ? 's' : '');
    }
    var numhours = Math.floor(((seconds % 31536000) % 86400) / 3600);
    if (numhours) {
        return numhours + ' hour' + ((numhours > 1) ? 's' : '');
    }
    var numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);
    if (numminutes) {
        return numminutes + ' minute' + ((numminutes > 1) ? 's' : '');
    }
    var numseconds = (((seconds % 31536000) % 86400) % 3600) % 60;
    if (numseconds) {
        return numseconds + ' second' + ((numseconds > 1) ? 's' : '');
    }
    return 'less then a second'; //'just now' //or other string you like;
}
// thanks http://stackoverflow.com/questions/1685680/how-to-avoid-scientific-notation-for-large-numbers-in-javascript
function toFixed(x) {
    if (Math.abs(x) < 1.0) {
        var e = parseInt(x.toString().split('e-')[1]);
        if (e) {
            x *= Math.pow(10, e - 1);
            x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
        }
    }
    else {
        var e = parseInt(x.toString().split('+')[1]);
        if (e > 20) {
            e -= 20;
            x /= Math.pow(10, e);
            x += (new Array(e + 1)).join('0');
        }
    }
    return x;
}
// thanks http://stackoverflow.com/questions/995183/how-to-allow-only-numeric-0-9-in-html-inputbox-using-jquery
$("#nodes").keydown(function (event) {
    // Allow: backspace, delete, tab, escape, and enter
    if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
        // Allow: Ctrl+A
        (event.keyCode == 65 && event.ctrlKey === true) ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)) {
        // let it happen, don't do anything
        return;
    }
    else {
        // Ensure that it is a number and stop the keypress
        if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
            event.preventDefault();
        }
    }
});
//----------------------------------------------------------//
//-------------- End : Password Strenght Check---------------//
//----------------------------------------------------------//
function allowOnlyNumeric(evt) {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    if ((key >= 48 && key <= 57) || key == 8 || key == 9 || key == 13 || key == 46 || key == 37 || key == 39)
        return true;
    else
        return false;
}
//----------------------------------------------------------------//
//------------------------Form Configuration----------------------//
//----------------------------------------------------------------//
function converttable(orientation) {
    var PageSize = 'A4';
    if (orientation != '' && orientation != undefined)
        PageSize = 'A3';
    else
        orientation = "portrait";
    var roothref = document.getElementById("ApplicationRoot").href;
    if ($("[CLASS*=todatatable] tbody tr td div[CLASS*='Empty']").length == 0) {
        var table1 = $("[CLASS*=todatatable]").DataTable({
            lengthMenu: [[100, 75, 50, 25, 10], [100, 75, 50, 25, 10]],
            destroy: true,
            dom: 'Blfrtip',
            ordering: false,
            stateSave: true,
            buttons: [
                {
                    extend: 'excelHtml5',
                    //message: "Date: " + new Date().toLocaleString(),
                    footer: true,
                    text: '<img src="' + roothref + 'img/ExportExcel.JPG" height="25"/>',
                    exportOptions: {
                        columns: ':not(".no")'
                    }
                    //titleAttr: 'Excel',
                    //  className: 'excelbtn'
                },
                {
                    extend: 'pdfHtml5',
                    //message: "Date: " + new Date().toLocaleString(),
                    footer: true,
                    pageSize: PageSize,
                    orientation: orientation,
                    //title: "Report",
                    text: '<img src="' + roothref + 'img/ExportPdf.png" height="25" />',
                    exportOptions: {
                        columns: ':not(".no")',
                        srtipHtml: false
                    },
                    customize: function (doc) {
                        doc.defaultStyle.fontSize = 9;
                        doc.content[1].table.widths = '',
                            doc.styles = {
                                tableHeader: {
                                    bold: true,
                                    fontSize: 9,
                                    color: 'black',
                                    fillColor: 'white',
                                    alignment: 'left'
                                },
                                tableBodyEven: {},
                                tableBodyOdd: {
                                    fillColor: '#eef2f3'
                                },
                                tableFooter: {
                                    bold: true,
                                    fontSize: 9,
                                    color: 'black',
                                    fillColor: 'white'
                                },
                                title: {
                                    alignment: 'center',
                                    fontSize: 15
                                }
                            };
                    }
                }
            ],
            "footerCallback": function (row, data, start, end, display) {
                var api = this.api(), data;
                // Remove the formatting to get integer data for summation
                this.api().columns('.sum', { search: 'applied' }).every(function () {
                    var column = this;
                    var data1 = column
                        .data();
                    var sum = data1.length > 1 ?
                        data1
                            .reduce(function (a, b) {
                            if (isNaN(a)) {
                                a = $(a).text();
                            }
                            if (isNaN(b)) {
                                b = $(b).text();
                            }
                            return parseFloat(a) + parseFloat(b);
                        }) : data1.length == 1 ?
                        parseFloat($(data1[0]).text())
                        : 0;
                    $(column.footer()).html(parseFloat(sum).toFixed(2));
                });
                //var cols = [1, 4];
                //$(cols).each(function () {
                //// Total over all pages
                //data = api.column(this, { search: 'applied' }).data();
                //total = data.length ?
                //    data.reduce(function (a, b) {
                //        return intVal(a) + intVal(b);
                //    }) :
                //    0;
                //// Total over this page
                //data = api.column(this, { page: 'current' }, { search: 'applied' }).data();
                //pageTotal = data.length ?
                //    data.reduce(function (a, b) {
                //        return intVal(a) + intVal(b);
                //    }) :
                //    0;
                //alert(total);
                //$(api.column(this).footer()).html(total);
                //})
            }
        });
    }
}
//# sourceMappingURL=widgets.js.map